// extracted by mini-css-extract-plugin
export default {"menu":"UserMenu_menu__ykfqC","menu_btn":"UserMenu_menu_btn__J9dQt"};